import { Injectable } from '@angular/core';
import { OrderType } from '@cureskin/api-client/src/server-api';
import { AppConfig } from 'client/app/app.config';
import { Table } from '@cureskin/api-client';

@Injectable({
  providedIn: 'root',
})

export class OrderHelper {
  constructor(
    private readonly appConfig: AppConfig,
  ) {}

  filterOrdersByType(orders: Array<Table.Order>, type: string): Array<Table.Order> {
    if (!orders) {
      return [];
    }
    return orders.filter((order: any): boolean => order.get('type') === type);
  }

  isOrderTypeRegimen(orderType: OrderType): boolean {
    return orderType === this.appConfig.Shared.Order.Type.REGIMEN;
  }

  sortOrdersByDeliveredOn(orders: Array<Table.Order>, ascending: boolean = false): Array<Table.Order> {
    if (!orders) {
      return [];
    }

    return orders.sort((a, b) => {
      const dateA = new Date(a.get('deliveredOn')).getTime();
      const dateB = new Date(b.get('deliveredOn')).getTime();
      return ascending ? dateA - dateB : dateB - dateA;
    });
  }
}
